module.exports = __webpack_public_path__ + "static/media/1POLICY45.ca46620d.jpg";